/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

function centerSiteLogo(){
  let logos = document.getElementsByClassName("site-header__logo-wrapper"),
      languages = document.getElementsByClassName("translation-lab-language-switcher");
  if(logos.length > 0 && languages.length > 0 && window.innerWidth > 450){
      let logo = logos[0],
          language = languages[0];
    logo.style.marginLeft = language.offsetWidth + 'px';
  }
};


function renderAccordion(){
	let acc = document.getElementsByClassName("accordion");

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
              to highlight the button that controls the panel */
      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
}

centerSiteLogo();
renderAccordion();